import React from 'react';

interface Event {
  id: number;
  name: string;
}

interface EventSelectorProps {
  events: Event[];
  selectedEventIds: Set<number>;
  onToggleEvent: (eventId: number) => void;
  disabled?: boolean;
}

const EventSelector: React.FC<EventSelectorProps> = ({
  events,
  selectedEventIds,
  onToggleEvent,
  disabled = false,
}) => {
  return (
    <div className="form-group-modern">
      <label>Événements invité *</label>
      <div className="event-checkboxes">
        {events.map((event) => (
          <label key={event.id} className="event-checkbox-label">
            <input
              type="checkbox"
              checked={selectedEventIds.has(event.id)}
              onChange={() => onToggleEvent(event.id)}
              disabled={disabled}
            />
            <span>{event.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default EventSelector;
